var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6066 19.3934C23.9729 17.7596 22.0283 16.5502 19.9066 15.8181C22.179 14.253 23.6719 11.6337 23.6719 8.67188C23.6719 3.89021 19.7817 0 15 0C10.2183 0 6.32812 3.89021 6.32812 8.67188C6.32812 11.6337 7.82103 14.253 10.0935 15.8181C7.9718 16.5502 6.02719 17.7596 4.39342 19.3934C1.56029 22.2265 0 25.9934 0 30H2.34375C2.34375 23.0213 8.02131 17.3438 15 17.3438C21.9787 17.3438 27.6562 23.0213 27.6562 30H30C30 25.9934 28.4397 22.2265 25.6066 19.3934ZM15 15C11.5107 15 8.67188 12.1613 8.67188 8.67188C8.67188 5.1825 11.5107 2.34375 15 2.34375C18.4893 2.34375 21.3281 5.1825 21.3281 8.67188C21.3281 12.1613 18.4893 15 15 15Z",
    fill: "#04385D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/Agent.55c286ac01df51942c5faebcddb3c4bf.svg";
export { ForwardRef as ReactComponent };